var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMinimumAge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.68 18.49L12.45 20.59L11.06 18.42L16 14.5H18.77V29.46H15.68V18.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.43 25.0998C20.43 23.4898 21.26 22.0798 22.85 21.4098C21.83 20.7398 21.33 19.6498 21.33 18.3198C21.33 16.0298 23.15 14.2798 26.18 14.2798C29.21 14.2798 31 16.0298 31 18.3198C31 19.6598 30.49 20.7398 29.48 21.4098C31.07 22.0798 31.9 23.4898 31.9 25.0998C31.9 27.8198 29.73 29.7198 26.18 29.7198C22.63 29.7198 20.43 27.8298 20.43 25.0998ZM28.65 24.8198C28.65 23.5998 27.8 22.5798 26.18 22.5798C24.56 22.5798 23.69 23.5998 23.69 24.8198C23.69 26.0398 24.59 26.9898 26.18 26.9898C27.77 26.9898 28.65 26.0398 28.65 24.8198ZM28.17 18.6798C28.17 17.6898 27.45 16.8598 26.18 16.8598C24.91 16.8598 24.2 17.6898 24.2 18.6798C24.2 19.6698 24.85 20.5298 26.18 20.5298C27.51 20.5298 28.17 19.6498 28.17 18.6798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.46 1.56982H35.07V13.1898H38.46V1.56982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.57 5.68018H30.95V9.07018H42.57V5.68018Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.34 16.15C39.99 18.02 40.34 20.02 40.34 22.11C40.34 32.16 32.16 40.34 22.11 40.34C12.06 40.34 3.87 32.16 3.87 22.11C3.87 12.06 12.05 3.87 22.11 3.87C24.15 3.87 26.1 4.21 27.93 4.83V0.78C26.08 0.27 24.12 0 22.11 0C9.9 0 0 9.9 0 22.11C0 34.32 9.9 44.22 22.11 44.22C34.32 44.22 44.22 34.32 44.22 22.11C44.22 20.04 43.94 18.05 43.41 16.15H39.35H39.34Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.21,
    height: 44.21,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimumAge);
export default __webpack_public_path__ + "static/media/minimum-age.ad9b6798d389d2730e66ce7f8b90c709.svg";
export { ForwardRef as ReactComponent };